import React from 'react'
import { Feature } from '../../components'
import './aboutus.css'

const AboutUs = () => {
  return (
    <div className='omit__aboutus section__margin' id='aboutus'>
      <div className='omit__aboutus-feature'>
        <Feature
          title='Our road so far'
          text='As a well-established European company, we won the trust of multiple customers working all over the region with our high-caliber tech support services.'
        />
      </div>
      <div className='omit__aboutus-heading'>
        <h1 className='gradient__text'>
          We can thoroughly analyze your needs to start delivering the best
          outcomes
        </h1>
        <p>Explore Our Services</p>
      </div>
      <div className='omit__aboutus-container'>
        <Feature
          title='High-End Web Development'
          text='We provide complex and expert-level Web Development Services way beyond regular website building '
        />
        <Feature
          title='Agile IT Project Management'
          text='Ensure high quality and excellent delivery by turning to comprehensive IT Project Management Consultancy'
        />
        <Feature
          title='Top-notch outsourcing support'
          text='Secure seamless workflows for your product, infrastructure, and cloud'
        />
      </div>
    </div>
  )
}

export default AboutUs
